import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[footerSection]',
    standalone: true
})
export class FooterSectionDirective {

  constructor(
    public viewContainerRef: ViewContainerRef
  ) { }

}
